import { FunctionComponent, useEffect, useState } from 'react'
import { Grid } from '@material-ui/core'

import Button from 'shared/components/Button'
import ContainerPage from 'shared/components/ContainerPage'
import SizedBox from 'shared/components/SizedBox'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import dimensions from 'shared/styles/dimensions'
import SnackBar from 'shared/components/SnackBar'
import { IContato } from 'modules/faleConosco/domain/usecases/BuscarContatos'
import ContatoData from 'modules/faleConosco/domain/entities/Contato'

import Contato from './Contato'
import { Container, Padding } from './styles'

type TProps = {
  getContatos: IContato
}

const DetalhesFaleConosco: FunctionComponent<TProps> = ({ getContatos }) => {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [openErrorMessage, setOpenErrorMessage] = useState(false)
  const [contatos, setContatos] = useState<ContatoData[]>([])

  useEffect(() => {
    async function fetchContatos() {
      setLoading(true)
      setOpenErrorMessage(false)

      try {
        const contatoResponse = await getContatos.execute()
        setContatos(contatoResponse)

        setLoading(false)
      } catch (e: unknown) {
        if (e instanceof Error) {
          setErrorMessage(e.message)
        } else {
          setErrorMessage('Erro ao buscar contatos')
        }
        setOpenErrorMessage(true)
        setLoading(false)
      }
    }

    fetchContatos()
  }, [getContatos])

  return (
    <>
      <ContainerPage
        breadCrumb="Fale Conosco"
        showFooterScaffold={false}
        loading={loading}
      >
        <Container>
          <Grid container spacing={4}>
            <Grid item xl={5} sm={5}>
              <Text color={colors.blue} size={14}>
                Central de atendimento
              </Text>
              <Padding>
                <Text color={colors.grayDark} size={14} weight={'700'}>
                  0800 701 3526
                </Text>
              </Padding>
            </Grid>
            <Grid item xl={7} sm={7}>
              <Text>Filiais</Text>
              <Padding>
                <Button
                  color={colors.orange}
                  onClick={() =>
                    window.open(
                      process.env.REACT_APP_FALE_CONOSCO_URL,
                      '_blank',
                    )
                  }
                >
                  Clique aqui e acesse
                </Button>
              </Padding>
            </Grid>
            <Grid item xl={12} sm={12} xs={12}>
              <hr />
            </Grid>
            {contatos.map(contato => {
              return (
                <Grid key={contato.regiao} item xl={12} sm={12}>
                  <Text weight="700">{contato.regiao}</Text>
                  <SizedBox size={dimensions.small} />
                  <Contato
                    contato={contato.nome}
                    telefone={contato.telefone}
                    cargo={contato.cargo}
                  />
                </Grid>
              )
            })}
          </Grid>
        </Container>
      </ContainerPage>
      <SnackBar
        open={openErrorMessage}
        setOpen={setOpenErrorMessage}
        severity="error"
        message={errorMessage}
      />
    </>
  )
}

export default DetalhesFaleConosco
